export default function GalleryList(){
  const photos = Array.from({ length: 30 }).map((_, i) => ({
    id: i + 1,
    src: `https://picsum.photos/seed/gall${i}/900/700`,
    w: i % 5 === 0 ? 2 : 1,
    h: i % 7 === 0 ? 2 : 1,
  }));

  return (
    <section className="container py-16">
      <div className="max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-bold">Gallery</h1>
        <p className="text-gray-600 mt-2">Browse the full collection of travel photos and find inspiration for your next trip.</p>
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-[140px] md:auto-rows-[180px]">
        {photos.map(p => (
          <div key={p.id} className={`overflow-hidden rounded-2xl ${p.h===2? 'row-span-2':''} ${p.w===2? 'col-span-2':''}`}>
            <img src={p.src} alt={`Gallery ${p.id}`} className="w-full h-full object-cover"/>
          </div>
        ))}
      </div>
    </section>
  );
}
